import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '../../redux-stores/store'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCollaborationsTasksThunk } from '../../redux-stores/slices/CollaborationsTasksSlice';
import { generateUniqueKey, isDateMoreThanDaysAgo } from '../../utils/helpers';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import ApplicationCard from './ApplicationCard';
import Skeleton from 'react-loading-skeleton';

const OngoingApplications = () => {
    const dispatch: AppDispatch = useDispatch();
    const [filters, setFilters] = useState({
        page: 1,
        limit: 10,
        q: '',
    })

    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));
    const ongoingApplications = useSelector((state: RootState) => state.collaborationTasks.filtered_lists[filterId]);
    const applications = (ongoingApplications?.list ?? []).filter((application: any) => !isDateMoreThanDaysAgo(application.milestones[0]?.ended_at_tz, 90));
    const page = ongoingApplications?.page ?? 1;
    const has_more = ongoingApplications?.has_more ?? true;
    const [pageLoading, setPageLoading] = useState(false);

    const loading = useSelector((state: RootState) => state.collaborationTasks.loading);

    useEffect(() => {
        setFilterId(generateUniqueKey(filters, ['page']));
    }, [filters])

    const getOngoingApplications = async (page: number = 1, force: boolean = false) => {
        try {
            setPageLoading(true);
            await dispatch(fetchCollaborationsTasksThunk({ filters: { ...filters, page }, force }));
        } catch (error) {
            console.log('err', error);
        } finally {
            setPageLoading(false);
        }
    }

    useEffect(() => {
        getOngoingApplications();
    }, [])

    const nextPage = () => {
        if (has_more && !loading) {
            const nextPageNumber = page + 1;
            getOngoingApplications(nextPageNumber);
        }
    }

    return (
        <div>
            <InfiniteScroll
                dataLength={applications.length}
                next={nextPage}
                hasMore={has_more}
                loader={<></>}
                className='d-flex flex-column gap-3 p-3'
            >
                {applications.map((application, index) => (
                    <ApplicationCard key={index} application={application} />
                ))}
                {
                    pageLoading && <Skeleton height={170} width={'100%'} borderRadius={'1rem'} count={5} className='mb-3' />
                }
                {
                    !pageLoading && (applications.length === 0) && (
                        <div className='d-flex py-5 my-5 flex-column align-items-center justify-content-center h-100'>
                            <span className='fs-16 text-muted fw-400'>No ongoing applications</span>
                        </div>
                    )
                }
            </InfiniteScroll>
        </div>
    )
}

export default OngoingApplications